<template>
  <div id="app" class="wrapper">
    <!-- header area start -->
    <header id="sticker" class="header-area">
      <div :class="fixTop ? 'fixed' : ''" class="row fixedTop" style="margin: 0">
        <div class="col-sm-12">
          <!-- mainmenu start -->
          <div class="hidden-xs mainmenu">
            <nav class="navbar-collapse">
              <ul class="nav text-center">
                <img src="./assets/logo.png" style="height: 40px;margin-right: 30px" alt="">
                <li v-for="(item,firstIndex) in menuList" :key="firstIndex"
                    :class="{ active: String(firstIndex) === currentFirstIndex}"
                    class="first-li dropdownList" @click="setFirstFocus(firstIndex)">
                  <a :href="item.link" class="topMenu">{{ item.name }}</a>
                  <div v-if="item.child !== undefined" class="dropdown-ul">
                    <ul class="second-ul">
                      <li v-for="(secondItem,secondIndex) in item.child" :key="secondIndex"
                          :class="{ active: String(firstIndex) === currentFirstIndex && String(secondIndex) === currentSecondIndex}"
                          class="second-li childDropdownList" @click.stop="setHeadSecondFocus(firstIndex, secondIndex)">
                        <a :href="secondItem.link">{{ secondItem.name }}</a>
                        <div v-if="secondItem.child !== undefined" class="child-dropdown-ul">
                          <ul class="third-ul">
                            <li v-for="(thirdItem, thirdIndex) in secondItem.child" :key="thirdIndex"
                                :class="{ active: String(firstIndex) === currentFirstIndex && String(secondIndex) === currentSecondIndex && String(thirdIndex) === currentThirdIndex}"
                                @click.stop="setHeadThirdFocus(firstIndex, secondIndex, thirdIndex)">
                              <a :href="thirdItem.link">{{ thirdItem.name }}</a>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
          <!-- mainmenu end -->
        </div>
      </div>
    </header>
    <div class="main-box container">
      <div v-if="currentFirstIndex !== '0'" class="left-content">
        <div class="nav-menu">
          <!--          一级菜单-->
          <ul class="main-first-ul">
            <li v-for="(item,firstIndex) in menuList"
                :class="{selectedSecondLi: String(firstIndex) === currentFirstIndex && currentSecondIndex === '' && currentThirdIndex === ''}"
                :key="firstIndex"
                @click="setFirstFocus(firstIndex)">
              <a :href=item.link
                 :class="{hadIcon: item.child !== undefined, selectedA: String(firstIndex) === currentFirstIndex}"
              >{{item.name}}</a>
              <!--              二级菜单-->
              <ul v-if="item.child !== undefined"
                  :class="{collapse_class: String(firstIndex) === currentFirstIndex}"
                  class="main-second-ul">
                <li v-for="(secondItem,secondIndex) in item.child"
                    :class="{selectedSecondLi: String(secondIndex) === currentSecondIndex && currentThirdIndex === ''}"
                    :key="secondIndex"
                    @click.stop="setSecondFocus(secondIndex)">
                  <a :href=secondItem.link
                     :class="{hadIcon: secondItem.child !== undefined, selectedA: String(secondIndex) === currentSecondIndex}"
                  >{{secondItem.name}}</a>
                  <!--                  三级菜单-->
                  <ul v-if="secondItem.child !== undefined"
                      :class="{collapse_class: String(secondIndex) === currentSecondIndex}"
                      class="main-third-ul">
                    <li v-for="(thirdItem,thirdIndex) in secondItem.child"
                        :class="{selectedSecondLi: String(thirdIndex) === currentThirdIndex}"
                        :key="thirdIndex"
                        @click.stop="setThirdFocus(thirdIndex)">
                      <a :href=thirdItem.link>{{thirdItem.name}}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <router-view
        :class="{rightContent: currentFirstIndex !== '0'}"
        v-on:headCurrent="headCall"
        class="whole-width"
      ></router-view>
    </div>

    <!-- footer top area start -->
    <div class="footer-top-area">
      <div class="container">
        <div class="row">
          <div class="footer-top-right col-xs-12 col-sm-12 col-md-12">
            <div class="row">
              <div class="col-sm-12 col-md-2">
                <div class="widget-title">
                  <h4>新闻中心</h4>
                </div>
                <div class="widget-content">
                  <ul class="footer-link">
                    <li><a href="/#/newsDetail" title="" @click="setHeadThirdFocus(3,0,'')">公司新闻</a></li>
                  </ul>
                </div>
              </div>
              <div class="col-sm-12 col-md-2">
                <div class="widget-title">
                  <h4>产品中心</h4>
                </div>
                <div class="widget-content">
                  <ul class="footer-link">
                    <li><a href="/#/vibrate" title="" @click="setHeadThirdFocus(1,0,'')">振动传感器系列</a></li>
                    <li><a href="/#/device" title="" @click="setHeadThirdFocus(1,1,'')">数据采集仪系列</a></li>
                    <li><a href="/#/GV" title="" @click="setHeadThirdFocus(1,2,'')">位移计系列</a></li>
                    <li><a href="/#/QYM" title="" @click="setHeadThirdFocus(1,3,'')">倾角仪系列</a></li>
                    <li><a href="/#/cloud" title="" @click="setHeadThirdFocus(1,4,'')">分布式在线监测平台</a></li>
                    <li><a href="/#/wave" title="" @click="setHeadThirdFocus(1,5,'')">数据分析软件</a></li>
                    <li><a href="/#/vibrostand" title="" @click="setHeadThirdFocus(1,6,'')">振动台系列</a></li>
                  </ul>
                </div>
              </div>
              <div class="col-sm-12 col-md-2">
                <div class="widget-title">
                  <h4>关于博远</h4>
                </div>
                <div class="widget-content">
                  <ul class="footer-link">
                    <li><a href="/#/aboutCompany" title="" @click="setHeadThirdFocus(5,0,'')">公司简介</a></li>
                    <li><a href="/#/aboutCertificate" title="" @click="setHeadThirdFocus(5,1,'')">资质及相关证书</a></li>
                  </ul>
                </div>
              </div>
              <div class="col-sm-12 col-md-2">
                <div class="widget-title">
                  <h4>下载中心</h4>
                </div>
                <div class="widget-content">
                  <ul class="footer-link">
                    <li><a href="/#/downloadList" title="" @click="setHeadThirdFocus(4,0,'')">产品说明书</a></li>
                  </ul>
                </div>
              </div>
              <div class="col-sm-12 col-md-2">
                <div class="widget-title">
                  <h4>加入我们</h4>
                </div>
                <div class="widget-content">
                  <ul class="footer-link">
                    <li><a href="/#/join" title="" @click="setHeadThirdFocus(6,0,'')">人才招聘</a></li>
                  </ul>
                </div>
              </div>
              <div class="col-sm-12 col-md-2">
                <div class="widget-title">
                  <h4>联系我们</h4>
                </div>
                <div class="widget-content">
                  <ul class="footer-link">
                    <li><a href="/#/contact" title="" @click="setHeadThirdFocus(7,'','')">联系我们</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer top area end -->

    <!-- footer area start -->
    <footer class="footer-area">
      <div class="container">
        <div class="row">
          <div class="bottom-block copyright col-xs-12 col-sm-12">
            <p style="margin: 0;text-align: center;">
              <span>Copyright © 2021 浙江博远电子科技有限公司 <a href="http://beian.miit.gov.cn"> 浙ICP备17041123号-2</a> <img src="./assets/bei.png"  alt="" /><a href="https://beian.mps.gov.cn/#/query/webSearch?code=33049802000375" rel="noreferrer" target="_blank">浙公网安备33049802000375</a></span>
            </p>
          </div>
        </div>
      </div>
    </footer>
    <!-- footer area end -->

    <div v-show="showTop" class="toTop" @click="scrollToTop">
      <span class="fa fa-angle-double-up"></span>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'App',
  data () {
    return {
      toTop: false,
      currentFirstIndex: sessionStorage.getItem('currentFirstIndex') !== null ? sessionStorage.getItem('currentFirstIndex') : '0',
      currentSecondIndex: sessionStorage.getItem('currentSecondIndex') !== null ? sessionStorage.getItem('currentSecondIndex') : '',
      currentThirdIndex: sessionStorage.getItem('currentThirdIndex') !== null ? sessionStorage.getItem('currentThirdIndex') : '',
      showTop: false,
      fixTop: false,
      contactData: {
        address: '',
        email: '',
        phone: '',
        work_time: ''
      },
      logoImg: '',
      copyrightInfo: '',
      menuList: [
        {
          name: '首页',
          link: '/#/home'
        },
        {
          name: '产品中心',
          link: '/#/products',
          child: [
            {
              name: '振动传感器系列',
              link: '/#/vibrate',
              child: [
                {
                  name: 'BY-S07',
                  link: '/#/BY_S07'
                },
                {
                  name: '941B',
                  link: '/#/B941B'
                },
                {
                  name: '991B',
                  link: '/#/B991B'
                },
                {
                  name: 'BY-S07D',
                  link: '/#/BY_S07D'
                },
                {
                  name: 'P12H',
                  link: '/#/P12H'
                },
                {
                  name: 'BY-S02',
                  link: '/#/BY_S02'
                },
                {
                  name: 'IEPE系列',
                  link: '/#/IEPE'
                }
              ]
            },
            {
              name: '数据采集仪系列',
              link: '/#/Device',
              child: [
                {
                  name: 'D1000',
                  link: '/#/D1000'
                },
                {
                  name: 'D2000A',
                  link: '/#/D2000A'
                },
                {
                  name: 'D3000',
                  link: '/#/D3000'
                }
              ]
            },
            {
              name: '位移计系列',
              link: '/#/GV'
            },
            {
              name: '倾角仪系列',
              link: '/#/QYM'
            },
            {
              name: '分布式在线监测平台',
              link: '/#/cloud'
            },
            {
              name: '数据分析软件',
              link: '/#/wave'
            },
            {
              name: '振动台系列',
              link: '/#/vibrostand',
              child: [
                {
                  name: 'XS-1低频振动台系统',
                  link: '/#/XL'
                },
                {
                  name: 'LVT-系列小型地震模型',
                  link: '/#/LVT'
                }
              ]
            }
          ]
        },
        {
          name: '核心业务',
          link: '/#/center',
          child: [
            {
              name: '桥梁振动监测',
              link: '/#/bridge',
              child: [
                {
                  name: '模态测试',
                  link: '/#/modalTest'
                },
                {
                  name: '索力测试',
                  link: '/#/cableTest'
                },
                {
                  name: '地震或船撞测试',
                  link: '/#/earthquakeTest'
                }
              ]
            },
            {
              name: '大坝振动监测',
              link: '/#/dam'
            },
            {
              name: '井下振动监测',
              link: '/#/pit',
              child: [
                {
                  name: '矿井安全类',
                  link: '/#/mine'
                },
                {
                  name: '地脉动长期监测',
                  link: '/#/tremor'
                },
                {
                  name: '精密实验室选址振动监测和振动评价',
                  link: '/#/laboratory'
                }
              ]
            },
            {
              name: '高层结构振动监测',
              link: '/#/highRise'
            },
            {
              name: '风电振动监测',
              link: '/#/wind'
            },
            {
              name: '特殊精密场所振动监测',
              link: '/#/precision'
            }
          ]
        },
        {
          name: '新闻中心',
          link: '/#/news',
          child: [
            {
              name: '公司新闻',
              link: '/#/newsDetail'
              // child: [
              //   {
              //     name: '2018年12月',
              //     link: '/#/newsDetail'
              //   },
              //   {
              //     name: '2018年6月',
              //     link: '/#/newsDetail'
              //   },
              //   {
              //     name: '2018年7月',
              //     link: '/#/newsDetail'
              //   },
              //   {
              //     name: '2018年12月',
              //     link: '/#/newsDetail'
              //   }
              // ]
            }
          ]
        },
        {
          name: '下载中心',
          link: '/#/download',
          child: [
            {
              name: '产品说明书',
              link: '/#/downloadList'
              // child: [
              //   {
              //     name: 'BY-S07型低频振动传感器说明书',
              //     link: 'http://129.204.205.167:8000/static/941B.pdf'
              //   },
              //   {
              //     name: 'D3000数采卡说明书',
              //     link: 'http://129.204.205.167:8000/static/D3000.pdf'
              //   },
              //   {
              //     name: 'P12H型索力传感器说明书',
              //     link: 'http://129.204.205.167:8000/static/P12H.pdf'
              //   },
              //   {
              //     name: '941B型低频振动传感器使用说明书',
              //     link: 'http://129.204.205.167:8000/static/941B.pdf'
              //   }
              // ]
            }
          ]
        },
        {
          name: '关于博远',
          link: '/#/about',
          child: [
            {
              name: '公司简介',
              link: '/#/aboutCompany'
            },
            {
              name: '资质及证书',
              link: '/#/aboutCertificate'
            }
          ]
        },
        {
          name: '加入我们',
          link: '/#/join',
          child: [
            {
              name: '人才招聘',
              link: '/#/join'
            }
          ]
        },
        {
          name: '联系我们',
          link: '/#/contact'
        },
        // {
        //   name: '灵敏度查询',
        //   link: '/#/sensitivity'
        // },
        {
          name: '设备版本查询',
          link: '/#/notice'
        }
      ]
    }
  },
  watch: {
    '$route': function (to, from) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      this.showTop = false
      this.setMenuFocus()
    }
  },
  created () {
    document.addEventListener('click', (e) => {
      if (e.target.className !== 'topMenu') {
        $('.click_btn').removeClass('collapse_btn')
      }
    })
  },
  mounted () {
    this.setMenuFocus()

    window.addEventListener('scroll', () => {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 0) {
        this.fixTop = true
      } else {
        this.fixTop = false
      }

      if (scrollTop > 300) {
        this.showTop = true
      } else {
        this.showTop = false
      }
    })
  },
  methods: {
    setFirstFocus (val) {
      this.currentFirstIndex = String(val)
      sessionStorage.setItem('currentFirstIndex', val)
      this.currentSecondIndex = ''
      sessionStorage.setItem('currentSecondIndex', '')
      this.currentThirdIndex = ''
      sessionStorage.setItem('currentThirdIndex', '')
    },
    setSecondFocus (val) {
      this.currentSecondIndex = String(val)
      sessionStorage.setItem('currentSecondIndex', val)
      this.currentThirdIndex = ''
      sessionStorage.setItem('currentThirdIndex', '')
    },
    setHeadSecondFocus (first, second) {
      this.currentFirstIndex = String(first)
      sessionStorage.setItem('currentFirstIndex', first)
      this.currentSecondIndex = String(second)
      sessionStorage.setItem('currentSecondIndex', second)
      this.currentThirdIndex = ''
      sessionStorage.setItem('currentThirdIndex', '')
    },
    setThirdFocus (val) {
      this.currentThirdIndex = String(val)
      sessionStorage.setItem('currentThirdIndex', val)
    },
    setHeadThirdFocus (first, second, third) {
      this.currentFirstIndex = String(first)
      sessionStorage.setItem('currentFirstIndex', first)
      this.currentSecondIndex = String(second)
      sessionStorage.setItem('currentSecondIndex', second)
      this.currentThirdIndex = String(third)
      sessionStorage.setItem('currentThirdIndex', third)
    },
    setMenuFocus () {
      let pathList = [
        'home', 'products', 'center', 'news', 'download', 'about', 'join', 'contact', 'sensitivity'
      ]
      // let list = ['commercialDetail', 'residentialDetail', 'projectList']  二级、三级路由列表
      if (pathList.indexOf(this.$router.currentRoute.name) > -1) {
        let focus = pathList.indexOf(this.$router.currentRoute.name)
        this.setFirstFocus(focus)
      } else if (this.$router.currentRoute.name === 'indexDefault') {
        this.setFirstFocus(pathList.indexOf('home'))
      } else if (this.$router.currentRoute.name === 'products') {
        this.setFirstFocus(pathList.indexOf('products'))
      } else if (this.$router.currentRoute.name === 'center') {
        this.setFirstFocus(pathList.indexOf('center'))
      } else if (this.$router.currentRoute.name === 'news') {
        this.setFirstFocus(pathList.indexOf('news'))
      } else if (this.$router.currentRoute.name === 'download') {
        this.setFirstFocus(pathList.indexOf('download'))
      } else if (this.$router.currentRoute.name === 'about') {
        this.setFirstFocus(pathList.indexOf('about'))
      } else if (this.$router.currentRoute.name === 'sensitivity') {
        this.setFirstFocus(pathList.indexOf('sensitivity'))
      } else if (this.$router.currentRoute.name === 'contact') {
        this.setFirstFocus(pathList.indexOf('contact'))
      }
    },
    scrollToTop () {
      this.timer = setInterval(() => {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        if (osTop === 0) {
          clearInterval(this.timer)
        }
      }, 30)
    },
    headCall (msg) { // 回调方法，接收子组件传的参数
      if (msg.first !== undefined) {
        this[msg.first] = String(msg.firstIndex)
        sessionStorage.setItem(msg.first, msg.firstIndex)
        console.log('first first first', msg.firstIndex)
      }
      if (msg.second !== undefined) {
        this[msg.second] = String(msg.secondIndex)
        sessionStorage.setItem(msg.second, msg.secondIndex)
        console.log('second second second', msg.secondIndex)
      }
      if (msg.third !== undefined) {
        this[msg.third] = String(msg.thirdIndex)
        sessionStorage.setItem(msg.third, msg.thirdIndex)
        console.log('third third third', msg.thirdIndex)
      }
    }
  }
}

</script>
<!-- all -->
<style>
  #app {
    font-family: 宋体, Helvetica, Arial, sans-serif;
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  ul{
    list-style: none;
  }
  .toTop {
    position: fixed;
    bottom: 85px;
    right: 15px;
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    color: #fff;
    border-radius: 5px;
    background-color: #fcb102;
    -webkit-transition: all 0.5s ease 0s;
    transition: all 0.5s ease 0s;
    z-index: 9999 !important;
  }

  .toTop:hover {
    height: 50px;
  }
  .nav{
    display: block!important;
  }
  @media screen and (max-width: 768px) {
    .mainmenu {
      position: absolute;
      background: #0c1923;
      top: 45px;
      left: 0;
      width: 100%;
    }

    .mainmenu .nav ul li.hover a::before,
    .mainmenu .nav ul li.active a::before {
      width: 0;
      background: none;
    }

    .phone_ul li {
      display: block !important;
    }

    .navbar-collapse {
      border-top: none;
    }

    .img-box img:first-child{
      margin-left: 0;
      margin-right: 5px;
    }

    .img-box img{
      height: 30px;
      margin: 3px 0;
    }
  }

  .logo img{
    height: 84px;
    margin: 15px 0 15px 15px;
  }

  .fixedTop{
    background-image: linear-gradient(#2B77B1,#175387);
    background-image: -moz-linear-gradient(#2B77B1,#175387);
    background-image: -o-linear-gradient(#2B77B1,#175387);
    border-top: 1px solid #59A0CB;
    height: 47px;
  }
</style>

<!-- 侧边栏 nav-menu -->
<style>
  .main-box{
    display: flex;
    margin-top: 47px;
  }

  .left-content{
    width: 300px;
  }

  .nav-menu{
    width: 260px;
    margin-top: 55px;
    padding: 20px;
    z-index: 99999;
    background: #f6f6f6;
    overflow: auto;
    /*transform: translate3d(-100%,0,0);*/
    transition: all 0.5s;
  }

  .rightContent{
    width: calc(100% - 300px)!important;
  }

  .whole-width{
    width: 100%;
  }

  /* main-first-ul start */
  .main-first-ul{
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .main-first-ul li{
    line-height: 30px;
    position: relative;
    /*padding-left: 10px;*/
  }

  .selectedSecondLi > a{
    color: white;
    background: #059BD8;
  }

  .main-first-ul > li a{
    display: block;
    border-bottom: dashed 1px #ccc;
  }

  .main-first-ul > li > a{
    padding-left: 13px;
  }

  .main-first-ul > li > a.hadIcon:before{
    content: '';
    position: absolute;
    top: 10px;
    left: 3px;
    height: 8px;
    width: 10px;
    border-top: 5px #666 solid;
    border-left: solid 5px transparent;
    border-right: solid 5px transparent;
    border-bottom: solid 3px transparent;
    transition: all 0.3s;
    transform: rotate(-90deg);
  }

  .main-first-ul > li > a.selectedA.hadIcon:before{
    left: 0px;
    top: 12px;
    transition: all 0.3s;
    transform: rotate(0deg);
  }

  .main-second-ul{
    transition: all 0.5s;
    height: 0;
    display: none;
  }

  .main-second-ul.collapse_class{
    transition: all 0.5s;
    height: auto;
    display: block;
  }

  .main-second-ul > li > a{
    padding-left: 35px;
  }

  .main-second-ul > li > a.hadIcon:before{
    content: '';
    position: absolute;
    top: 10px;
    left: 24px;
    height: 8px;
    width: 10px;
    border-top: 5px #666 solid;
    border-left: solid 5px transparent;
    border-right: solid 5px transparent;
    border-bottom: solid 3px transparent;
    transition: all 0.3s;
    transform: rotate(-90deg);
  }

  .main-second-ul > li > a.selectedA.hadIcon:before{
    left: 21px;
    top: 12px;
    transition: all 0.3s;
    transform: rotate(0deg);
  }

  .main-third-ul{
    transition: all 0.5s;
    height: 0;
    display: none;
  }

  .main-third-ul.collapse_class{
    transition: all 0.5s;
    height: auto;
    display: block;
  }

  .main-third-ul > li > a{
    padding-left: 53px;
  }
</style>

<!-- footer -->
<style>
  .footer-top-right {
    padding-top: 40px;
    padding-bottom: 20px;
  }

  .footer-top-right ul {
    list-style: none;
    margin-bottom: 20px;
  }

  .about-us p{
    margin-bottom: 5px;
    color: white;
  }

  .social-link h4{
    margin: 0 0 15px;
    font-size: 20px;
    /*font-family: "Roboto Condensed",sans-serif;*/
    text-transform: uppercase;
    letter-spacing: 1.8px;
    font-weight: 700;
    line-height: 1.1;
    color: white;
  }

  .social-icons {
    margin-bottom: 0;
    margin-left: -5px;
  }

  .social-icons li {
    padding-bottom: 10px;
    display: inline-block;
    padding-right: 5px;
    padding-left: 5px;
  }

  .social-icons a {
    background-color: #f7f7f7;
    text-align: center;
    font-size: 25px;
    border-radius: 5px;
  }

  .social-icons a.twitter {
    color: #55acee;
  }

  .social-icons a.twitter:hover {
    color: white;
    background-color: #55acee;
  }

  .social-icons a.facebook {
    color: #3b5998;
  }

  .social-icons a.facebook:hover {
    color: white;
    background-color: #3b5998;
  }

  .social-icons a.youtube {
    color: #bb0000;
  }

  .social-icons a.youtube:hover {
    color: white;
    background-color: #bb0000;
  }

  .social-icons a.instagram {
    color: #125688;
  }

  .social-icons a.instagram:hover {
    color: white;
    background-color: #125688;
  }

  .footer-area .bottom-block{
    margin: 15px 0;
    line-height: 40px;
  }
</style>

<!-- drop down list -->
<style scoped>
  .dropdown-ul{
    position: absolute;
    top: 46px;
    left: 0;
    /*transform: translateX(-50%);*/
    z-index: 999;

    -moz-border-radius: 0 0 5px 5px;
    -webkit-border-radius: 0;
    border-radius: 0 0 5px 5px;
    -moz-box-shadow: 0 1px 2px #c7c7c7;
    -webkit-box-shadow: 0 1px 2px #c7c7c7;
    box-shadow: 0 1px 2px #c7c7c7;

    width: 200px!important;
    /*padding: 5px 0;*/
    background: #175387;
    visibility: hidden;
    opacity: 0;
    transition: all 0.3s;
  }

  .dropdownList:hover .dropdown-ul{
    visibility: visible;
    opacity: 1;
    transition: all 0.3s;
  }

  .second-ul .second-li{
    display: block;
    line-height: 30px;
    list-style: none;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
  }

  .second-ul .second-li:hover{
    background: #059BD8;
    transition: all 0.3s;
  }

  .second-ul .second-li a{
    display: inline-block;
    width: 100%;
    position: relative;
    font-size: 14px;
    font-weight: bold;
    color: #fff!important;
    text-transform: capitalize!important;
  }

  .second-ul .second-li:hover a{
    color: #fff!important;
  }

  .second-ul .second-li a:hover{
    color: #fff!important;
    background: none;
  }

  .second-ul .second-li a:before {
    content: "";
    width: 8px;
    height: 8px;
    margin-right: 8px;
    border: 1px solid #fff;
    display: inline-block;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
  }

  .child-dropdown-ul{
    position: absolute;
    top: 0;
    left: 100%;
    z-index: 999;

    -moz-border-radius: 0 5px;
    -webkit-border-radius: 0;
    border-radius: 0 5px;
    -moz-box-shadow: 0 1px 2px #c7c7c7;
    -webkit-box-shadow: 0 1px 2px #c7c7c7;
    box-shadow: 0 1px 2px #c7c7c7;

    width: 200px;
    /*padding: 5px 0;*/
    background: #175387;
    visibility: hidden;
    opacity: 0;
    transition: all 0.3s;
  }

  .childDropdownList:hover .child-dropdown-ul{
    visibility: visible;
    opacity: 1;
    transition: all 0.3s;
  }

  .third-ul li{
    display: block;
    line-height: 30px;
    list-style: none;
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
  }

  .third-ul li:hover{
    background: #059BD8;
    transition: all 0.3s;
  }

  .third-ul li a{
    display: inline-block;
    width: 100%;
    position: relative;
    font-size: 12px;
    font-weight: normal;
    color: #fecd32!important;
    text-transform: capitalize!important;
  }

  .third-ul li a:hover{
    background: none;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue